import axios from 'axios';
import { ICheckout, ICheckoutInstallment } from '../interfaces/ICheckout';
import { ISubscription } from '../interfaces/ISubscription';
import { API_URL, ENV } from '../settings';
import { decodeSearchParams } from '../utils/decodeSearchParams';

class CheckoutService {
  public async mountAsTransaction(transactionId: string): Promise<ICheckout> {
    const { data } = await axios.get(`${API_URL}/checkout/mount/transaction/${transactionId}`);

    return data;
  }

  public async mountAsCheckout(checkoutId: string, salesKey?: string): Promise<ICheckout> {
    const currentUrlParams = decodeSearchParams(window.location.search);
    const allParams: Record<string, any> = {};
    currentUrlParams.forEach((value, key) => {
      allParams[key] = value;
    });

    if (ENV === 'development') {
      allParams.skipCache = true;
    }

    allParams.s = salesKey || allParams.s || '';

    const { data } = await axios.get(`${API_URL}/checkout/mount/checkout/${checkoutId}`, {
      params: allParams,
    });

    return data;
  }

  public async mountAsSubscription(subscriptionId: string): Promise<ISubscription> {
    const { data } = await axios.get(`${API_URL}/checkout/mount/subscription/${subscriptionId}`);

    return data;
  }

  public async pay(payload: any) {
    const { data } = await axios.post(`${API_URL}/checkout/pay`, payload);

    return data;
  }

  public async changeSubscriptionPaymentMethods(payload: any) {
    const { data } = await axios.post(`${API_URL}/checkout/change-subscription-payment-methods`, payload);

    return data;
  }

  public async getResultByTransactionId(transactionId: string) {
    const { data } = await axios.get(`${API_URL}/checkout/result/${transactionId}`);

    return data;
  }

  public async getInstallments(data: any) {
    const { data: installments } = await axios.post<ICheckoutInstallment[]>(`${API_URL}/checkout/installments`, data);

    return installments;
  }

  public async generateAgreement(teamId: string, transactionId: string) {
    try {
      const { data } = await axios.post(`${API_URL}/checkout/agreements/${teamId}/${transactionId}`);

      return data;

    } catch (error) {
      console.error('Error generating agreement:', error);
      throw new Error('Falha ao gerar contrato');
    }
  }

  public async applyCoupon(teamId: string, items: ICheckout['items'], couponCode: string) {
    const { data } = await axios.post(`${API_URL}/checkout/apply-coupon`, {
      teamId, 
      items,
      couponCode,
    });

    return data;
  }
}

export const checkoutService = new CheckoutService();
